import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";

export default function Hero() {
    const { t } = useTranslation();
    const scrollNext = () => {
        const el = document.getElementById("preguntas");
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <section
            id="hero"
            data-testid="hero-section"
            className="relative pt-32 md:pt-44 pb-24 md:pb-36 bg-[#F4F1EA]"
        >
            <div className="max-w-[1200px] mx-auto px-6 md:px-12">
                <div className="max-w-[920px] av-fade-in">
                    <p className="overline">{t("hero.overline")}</p>
                    <h1
                        data-testid="hero-headline"
                        className="font-serif-display mt-8 text-[40px] leading-[1.06] sm:text-[56px] md:text-[68px] lg:text-[76px] lg:leading-[1.04] tracking-[-0.015em] text-[#1A1A1A]"
                    >
                        Tus mejores leads no deberían enfriarse mientras estás haciendo tu trabajo.
                    </h1>

                    <span className="block h-px w-16 bg-[#8B6914] mt-10" aria-hidden="true" />

                    <p
                        data-testid="hero-subhead"
                        className="mt-8 text-lg md:text-xl text-[#1A1A1A] leading-[1.65] max-w-[760px]"
                    >
                        Desplegamos sistemas que cualifican, agendan y dan seguimiento por ti.
                        Con criterio humano supervisándolos. Para profesionales, autónomos y empresas
                        con negocio validado — que quieren escalar sin contratar.
                    </p>

                    <div className="mt-12 flex flex-col sm:flex-row gap-5 sm:items-center">
                        <Link
                            to="/contacto"
                            data-testid="hero-cta-primary"
                            className="group inline-flex items-center justify-center gap-3 px-7 py-4 bg-[#1A1A1A] text-white text-sm tracking-wide hover:bg-[#8B6914] transition-colors duration-200"
                        >
                            {t("hero.cta_primary")}
                            <ArrowRight size={16} className="transition-transform group-hover:translate-x-0.5" />
                        </Link>
                        <button
                            onClick={scrollNext}
                            data-testid="hero-cta-secondary"
                            className="group text-sm tracking-wide text-[#1A1A1A] hover:text-[#8B6914] transition-colors duration-200"
                        >
                            <span className="border-b border-transparent group-hover:border-[#8B6914] pb-1">
                                {t("hero.cta_secondary")}
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
}
